import { ResourceCustomTheme } from "styles/config";

export const renderedTextEditorStyling = (
  theme: ResourceCustomTheme,
  variant: "body" | "header"
) =>
  variant === "body"
    ? {
        "& span[data-id]": theme.mixins.placeholderStyles(theme, "75%"),
        fontFamily: "Circular !important",
        background: "#fff !important",
        fontStyle: "normal",
        fontSize: "16px",
        lineHeight: "24px",
        "& ul": {
          listStyle: "disc",
          paddingInlineStart: "30px",
        },
        "& ol": {
          listStyle: "auto",
          paddingInlineStart: "39px",
        },
      }
    : {
        "& span[data-id]": {
          ...theme.mixins.placeholderStyles(theme, "67%"),
          padding: "0.5rem 0.7rem",
        },
      };
